module.exports = __webpack_public_path__ + "static/media/4.dcfa4a86.png";